import store from "../redux/store";
import {enqueueSnackbar} from "../redux/actions/snackbarActions";
import {errorMessage} from "./alertMessages";
import {AuthService} from "./AuthService";
import {redirectTo} from "../routes/functions";
import i18n from "../i18n";

export function handleError(error, message) {
  const errorMessages = [
    "Failed in authentication",
    "Bad permissions",
    "Invalid token",
    "Expired token"
  ];

  const isAuthError = error?.response?.status === 403 ||
    (error?.response?.data?.message && errorMessages.some(msg => error.response.data.message.includes(msg)));

  if (isAuthError) {
    AuthService.logout();
    redirectTo('/auth/sign-in');
    store.dispatch(enqueueSnackbar(errorMessage(i18n.t('errors:failedAuthentication'))));
    return true;
  }
  if (error?.response?.data?.message && error.response.data.message.includes("Access denied")) {
    store.dispatch(enqueueSnackbar(errorMessage(i18n.t('errors:accessDenied'))));
    return true;
  }
  store.dispatch(enqueueSnackbar(errorMessage(error?.response?.data?.message || message)));
  return false;
}